{
  "source": "legacy/cdm2026_v2.html + eloratings.net (snapshot 2026-06-12T23:00:00Z)",
  "eloDate": "2026-06-11",
  "eloNote": "elo = valeur réelle eloratings.net au 11/06/2026 (reconstituée par inversion pour les équipes ayant déjà joué) + ajustements forfaits déclarés (specs/00 : NED -22, BRA -10, CAN -12). eloLegacy = valeur du modèle legacy (~30 estimations, écarts constatés jusqu'à ±130 pts). Le flag estimated est obsolète : toutes les valeurs sont réelles.",
  "teams": [
    {
      "id": "MEX",
      "nameFr": "Mexique",
      "flagCode": "mx",
      "group": "A",
      "elo": 1875,
      "eloLegacy": 1806,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "RSA",
      "nameFr": "Afrique du Sud",
      "flagCode": "za",
      "group": "A",
      "elo": 1517,
      "eloLegacy": 1645,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "KOR",
      "nameFr": "Corée du Sud",
      "flagCode": "kr",
      "group": "A",
      "elo": 1757,
      "eloLegacy": 1775,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CZE",
      "nameFr": "Tchéquie",
      "flagCode": "cz",
      "group": "A",
      "elo": 1741,
      "eloLegacy": 1760,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CAN",
      "nameFr": "Canada",
      "flagCode": "ca",
      "group": "B",
      "elo": 1776,
      "eloLegacy": 1833,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [
        "adjusted"
      ],
      "eloAdjustment": {
        "delta": -12,
        "reason": "forfaits déclarés (specs/00)"
      }
    },
    {
      "id": "BIH",
      "nameFr": "Bosnie-Herzégovine",
      "flagCode": "ba",
      "group": "B",
      "elo": 1595,
      "eloLegacy": 1690,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "QAT",
      "nameFr": "Qatar",
      "flagCode": "qa",
      "group": "B",
      "elo": 1421,
      "eloLegacy": 1630,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "SUI",
      "nameFr": "Suisse",
      "flagCode": "ch",
      "group": "B",
      "elo": 1891,
      "eloLegacy": 1897,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "BRA",
      "nameFr": "Brésil",
      "flagCode": "br",
      "group": "C",
      "elo": 1981,
      "eloLegacy": 1981,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [
        "adjusted"
      ],
      "eloAdjustment": {
        "delta": -10,
        "reason": "forfaits déclarés (specs/00)"
      }
    },
    {
      "id": "MAR",
      "nameFr": "Maroc",
      "flagCode": "ma",
      "group": "C",
      "elo": 1827,
      "eloLegacy": 1860,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "HTI",
      "nameFr": "Haïti",
      "flagCode": "ht",
      "group": "C",
      "elo": 1548,
      "eloLegacy": 1560,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "SCO",
      "nameFr": "Écosse",
      "flagCode": "gb-sct",
      "group": "C",
      "elo": 1782,
      "eloLegacy": 1800,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "USA",
      "nameFr": "États-Unis",
      "flagCode": "us",
      "group": "D",
      "elo": 1726,
      "eloLegacy": 1782,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "PAR",
      "nameFr": "Paraguay",
      "flagCode": "py",
      "group": "D",
      "elo": 1834,
      "eloLegacy": 1760,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "AUS",
      "nameFr": "Australie",
      "flagCode": "au",
      "group": "D",
      "elo": 1777,
      "eloLegacy": 1730,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "TUR",
      "nameFr": "Türkiye",
      "flagCode": "tr",
      "group": "D",
      "elo": 1911,
      "eloLegacy": 1885,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "GER",
      "nameFr": "Allemagne",
      "flagCode": "de",
      "group": "E",
      "elo": 1932,
      "eloLegacy": 1928,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CUW",
      "nameFr": "Curaçao",
      "flagCode": "cw",
      "group": "E",
      "elo": 1434,
      "eloLegacy": 1575,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CIV",
      "nameFr": "Côte d'Ivoire",
      "flagCode": "ci",
      "group": "E",
      "elo": 1695,
      "eloLegacy": 1780,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "ECU",
      "nameFr": "Équateur",
      "flagCode": "ec",
      "group": "E",
      "elo": 1938,
      "eloLegacy": 1938,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "NED",
      "nameFr": "Pays-Bas",
      "flagCode": "nl",
      "group": "F",
      "elo": 1926,
      "eloLegacy": 1926,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [
        "adjusted"
      ],
      "eloAdjustment": {
        "delta": -22,
        "reason": "forfaits déclarés (specs/00)"
      }
    },
    {
      "id": "JPN",
      "nameFr": "Japon",
      "flagCode": "jp",
      "group": "F",
      "elo": 1906,
      "eloLegacy": 1877,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "SWE",
      "nameFr": "Suède",
      "flagCode": "se",
      "group": "F",
      "elo": 1712,
      "eloLegacy": 1745,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "TUN",
      "nameFr": "Tunisie",
      "flagCode": "tn",
      "group": "F",
      "elo": 1628,
      "eloLegacy": 1700,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "BEL",
      "nameFr": "Belgique",
      "flagCode": "be",
      "group": "G",
      "elo": 1894,
      "eloLegacy": 1849,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "EGY",
      "nameFr": "Égypte",
      "flagCode": "eg",
      "group": "G",
      "elo": 1696,
      "eloLegacy": 1730,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "IRN",
      "nameFr": "Iran",
      "flagCode": "ir",
      "group": "G",
      "elo": 1772,
      "eloLegacy": 1755,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "NZL",
      "nameFr": "Nouvelle-Zélande",
      "flagCode": "nz",
      "group": "G",
      "elo": 1562,
      "eloLegacy": 1590,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "ESP",
      "nameFr": "Espagne",
      "flagCode": "es",
      "group": "H",
      "elo": 2157,
      "eloLegacy": 2154,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CPV",
      "nameFr": "Cap-Vert",
      "flagCode": "cv",
      "group": "H",
      "elo": 1578,
      "eloLegacy": 1580,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "KSA",
      "nameFr": "Arabie saoudite",
      "flagCode": "sa",
      "group": "H",
      "elo": 1576,
      "eloLegacy": 1670,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "URU",
      "nameFr": "Uruguay",
      "flagCode": "uy",
      "group": "H",
      "elo": 1892,
      "eloLegacy": 1890,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "FRA",
      "nameFr": "France",
      "flagCode": "fr",
      "group": "I",
      "elo": 2063,
      "eloLegacy": 2061,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "SEN",
      "nameFr": "Sénégal",
      "flagCode": "sn",
      "group": "I",
      "elo": 1860,
      "eloLegacy": 1875,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "IRQ",
      "nameFr": "Irak",
      "flagCode": "iq",
      "group": "I",
      "elo": 1607,
      "eloLegacy": 1690,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "NOR",
      "nameFr": "Norvège",
      "flagCode": "no",
      "group": "I",
      "elo": 1914,
      "eloLegacy": 1914,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "ARG",
      "nameFr": "Argentine",
      "flagCode": "ar",
      "group": "J",
      "elo": 2115,
      "eloLegacy": 2112,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "ALG",
      "nameFr": "Algérie",
      "flagCode": "dz",
      "group": "J",
      "elo": 1772,
      "eloLegacy": 1740,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "AUT",
      "nameFr": "Autriche",
      "flagCode": "at",
      "group": "J",
      "elo": 1830,
      "eloLegacy": 1830,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "JOR",
      "nameFr": "Jordanie",
      "flagCode": "jo",
      "group": "J",
      "elo": 1680,
      "eloLegacy": 1660,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "POR",
      "nameFr": "Portugal",
      "flagCode": "pt",
      "group": "K",
      "elo": 1989,
      "eloLegacy": 1989,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "COD",
      "nameFr": "RD Congo",
      "flagCode": "cd",
      "group": "K",
      "elo": 1652,
      "eloLegacy": 1690,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "UZB",
      "nameFr": "Ouzbékistan",
      "flagCode": "uz",
      "group": "K",
      "elo": 1714,
      "eloLegacy": 1700,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "COL",
      "nameFr": "Colombie",
      "flagCode": "co",
      "group": "K",
      "elo": 1982,
      "eloLegacy": 1982,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "ENG",
      "nameFr": "Angleterre",
      "flagCode": "gb-eng",
      "group": "L",
      "elo": 2024,
      "eloLegacy": 2021,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "CRO",
      "nameFr": "Croatie",
      "flagCode": "hr",
      "group": "L",
      "elo": 1912,
      "eloLegacy": 1908,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "GHA",
      "nameFr": "Ghana",
      "flagCode": "gh",
      "group": "L",
      "elo": 1510,
      "eloLegacy": 1610,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    },
    {
      "id": "PAN",
      "nameFr": "Panama",
      "flagCode": "pa",
      "group": "L",
      "elo": 1730,
      "eloLegacy": 1705,
      "eloSource": "eloratings.net — snapshot reconstitué au 11/06/2026",
      "eloFlags": [],
      "eloAdjustment": null
    }
  ]
}
